import { render } from "./read.vue?vue&type=template&id=1e2f8968"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"

import exportComponent from "/home/krupali/vuejs/borex-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__